export const AppRoutes = {
  indexPath: "/",
  landingPath: "/Landing",
  flightsPath: "/flights",
  selfCheckinPath: "/self_checkin",
  selfBoardingPath: "/self_boarding",
  demoChoicesPath: "/demo_choices",
  manageFlightPath: "/flights/:flightRecordId",
  manageBookingPath: "/bookings/:bookingCode",
  pagePath: "/page",
  scaleTestPath: "/scale_test"

}